import appConfig from '@/config/env';

import getAdminJwtAuthHeaders from './getAdminJwtAuthHeaders';

const getAdminApiBaseUrl = (): string => appConfig.API_URL.replace(/\/$/, '');

async function parseAdminJwtResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
        const text = await response.text().catch(() => '');
        throw new Error(text || `Admin JWT request failed: ${response.status}`);
    }
    return response.json() as Promise<T>;
}

/** GET against admin JWT-authorizer routes (Bearer Cognito id token, not IAM SigV4). */
export async function adminJwtGet<T>(path: string): Promise<T> {
    const headers = await getAdminJwtAuthHeaders();
    const response = await fetch(`${getAdminApiBaseUrl()}${path}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            ...headers,
        },
    });
    return parseAdminJwtResponse<T>(response);
}

/** POST against admin JWT-authorizer routes (Bearer Cognito id token, not IAM SigV4). */
export async function adminJwtPost<T>(path: string, body?: unknown): Promise<T> {
    const headers = await getAdminJwtAuthHeaders();
    const response = await fetch(`${getAdminApiBaseUrl()}${path}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers,
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    return parseAdminJwtResponse<T>(response);
}
